// @flow

import React from 'react'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import isRetina from 'is-retina'

import { colors } from '../style'

const logoSrc = isRetina() ? require('./logo@2x.png') : require('./logo.png')

const Root = styled.div`
  position: relative;

  padding: 15px 0;

  text-align: center;
`

const Logo = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
`

const Credits = styled.h2`
  margin: 0;

  font-size: .9em;
  font-weight: normal;
`

const CreditsPerson = styled.span`
  display: block;

  text-decoration: underline;

  color: ${colors.red};
`

const Title = styled.h1`
  color: ${colors.red};
`

const Contacts = styled.div`
  position: absolute;
  right: 30px;
  top: 30px;

  text-align: right;
`

const ContactLink = styled.a`
  display: block;

  text-decoration: none;

  color: #000;
`

function Header() {
  return (
    <Root>
      <Logo src={logoSrc} width={484} height={194} role="presentation" />
      <Credits>
        <FormattedMessage id="header.credits.request" />
        <CreditsPerson>
          <FormattedMessage id="header.credits.person" />
        </CreditsPerson>
      </Credits>
      <Title>
        <FormattedMessage id="header.title" />
      </Title>

      <Contacts>
        <ContactLink href="mailto:info@37practices.info">
          info@37practices.info
        </ContactLink>
        <ContactLink href="tel:+79269035959">
          +7 (926) 903-59-59
        </ContactLink>
      </Contacts>
    </Root>
  )
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js